import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LivePreviewService } from '../../shared/services/live-preview.service';
import { LeadGenerationStylesService } from '../../shared/services/lead-generation-styles.service';
import { AmplitudeService } from '../../../shared/services/amplitude.service';
import { Configuration } from '../../shared/domain/configuration.model';
import { ToastrService } from 'ngx-toastr';
import { getActiveProjectSelector } from '../../projects/projects.reducer';
import { IState } from '../../../shared/models/state';
import { Store } from '@ngrx/store';
import { UpdateProjectStyleAction } from '../../projects/projects.action';
import { MatDialog } from '@angular/material';
import { InfoDialogComponent } from '../../../shared/dialog/info-dialog/info-dialog.component';
import { ConfirmDialogComponent } from '../../../shared/dialog/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'cc-popup-creator',
  templateUrl: './popup-creator.component.html',
  styleUrls: ['./popup-creator.component.scss']
})
export class PopupCreatorComponent implements OnInit {
  public popupSettings: FormGroup;
  public advancedSettings: boolean;
  public isPopup: boolean;
  private config: Configuration;
  public insertHtml = new EventEmitter();

  constructor(
    private livePreviewService: LivePreviewService,
    private leadGenerationStylesService: LeadGenerationStylesService,
    private amplitudeService: AmplitudeService,
    private toastr: ToastrService,
    private store: Store<IState>,
    private dialog: MatDialog
  ) {
    this.amplitudeService.logEvent('Panel: Page View: Lead Generation Pop-up Editor');
  }

  ngOnInit() {
    this.popupSettings = this.leadGenerationStylesService.createPopUpForm();
    this.store.select(getActiveProjectSelector).subscribe((config: Configuration) => {
      this.config = config;
      this.leadGenerationStylesService.updateForm(this.popupSettings, this.config, 'popup');
      this.advancedSettings = this.config.popupStyle.custom.advanced;
    });
    this.popupSettings.valueChanges.subscribe(() => this.sendChanges());
    this.popupSettings.get('advanced').valueChanges.subscribe(value => {
      this.advancedSettings = value;
    });
    this.isPopup = true;
  }

  get currentProjectId() {
    return this.config.projectId;
  }

  sendChanges() {
    this.livePreviewService.sendToFrame('CHANGE_SETTINGS', this.popupSettings.value, undefined);
  }

  isIncorrectCustomHTML() {
    const htmlToCheck = document.createElement('html');
    htmlToCheck.innerHTML = this.popupSettings.get('customHTML').value;

    return ['input.cc-number-input', 'button.cc-button', 'div.cc-error-message'].some(
      selector => htmlToCheck.querySelectorAll(selector).length === 0
    );
  }

  saveDb() {
    if (this.advancedSettings && this.isIncorrectCustomHTML()) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          title: 'LEAD_GENERATION.INCORRECT_HTML_TITLE',
          body: 'LEAD_GENERATION.INCORRECT_HTML_INFO'
        }
      });
      return;
    }

    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'LEAD_GENERATION.CONFIRMATION_TITLE',
          body: 'LEAD_GENERATION.CONFIRMATION_POPUP_INFO'
        }
      })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.amplitudeService.logEvent('Panel: Lead Generation: Pop-up Published');
          this.store.dispatch(
            new UpdateProjectStyleAction({ type: 'POPUP', body: this.popupSettings.value, config: this.config })
          );
        }
      });
  }

  handleAdvancedSettingsClick() {
    this.popupSettings.get('advanced').setValue(!this.popupSettings.get('advanced').value);
    window.scroll(0, 0);
  }

  onChangeEditorCode(code, formField) {
    this.popupSettings.get(formField).setValue(code);
  }

  onChangePreviewType(isPopup) {
    this.isPopup = isPopup;
  }

  addInput() {
    this.insertHtml.next('<input type="text" class="cc-number-input"/>');
  }

  addButton() {
    this.insertHtml.next('<button class="cc-button">Ok</button>');
  }

  addDiv() {
    this.insertHtml.next('<div class="cc-error-message">Not valid phone number</div>');
  }
}
